import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const CareersPage = () => {
  return (
    <>
      <SEO 
        title="Careers - Join Abacies Logiciels"
        description="Join Abacies Logiciels and build your career with a leading AI and software development company. Explore opportunities in engineering, AI, cloud, and digital transformation."
        keywords="careers, jobs, employment, software engineering jobs, AI jobs, technology careers, Abacies careers"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Careers
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Careers page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Careers. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default CareersPage;
